import LanguagePreferenceBar from './LanguagePreferenceBar';

export default LanguagePreferenceBar;
